import config from '../config';
import { SIDEBAR, SIDEBAR_STORAGE_KEY, clampSidebarWidth } from './constant';
import { ACTIVE_PALETTE, PALETTE_CHOICES, PALETTE_STORAGE_KEY } from '../themes/tokens';
import * as actionTypes from './actions';

export const THEME_STORAGE_KEY = 'ui.themeMode';

const readSavedThemeMode = () => {
  try {
    const saved = window.localStorage.getItem(THEME_STORAGE_KEY);
    if (saved === 'light' || saved === 'dark') return saved;
  } catch (e) {
  }
  return config.defaultThemeMode === 'light' ? 'light' : 'dark';
};

const readSavedSidebar = () => {
  try {
    const saved = JSON.parse(window.localStorage.getItem(SIDEBAR_STORAGE_KEY) || 'null');
    if (saved && typeof saved === 'object') {
      return { opened: saved.opened !== false, width: clampSidebarWidth(saved.width) };
    }
  } catch (e) {
  }
  return { opened: true, width: SIDEBAR.defaultWidth };
};

const savedSidebar = readSavedSidebar();

const isKnownPalette = (id) => PALETTE_CHOICES.some((p) => p.id === id);
const readSavedPalette = () => {
  try {
    const saved = window.localStorage.getItem(PALETTE_STORAGE_KEY);
    if (isKnownPalette(saved)) return saved;
  } catch (e) {
  }
  return ACTIVE_PALETTE;
};

export const initialState = {
  isOpen: [],
  defaultId: 'default',
  fontFamily: config.fontFamily,
  borderRadius: config.borderRadius,
  opened: savedSidebar.opened,
  sidebarWidth: savedSidebar.width,
  navType: readSavedThemeMode(),
  palette: readSavedPalette()
};

const customizationReducer = (state = initialState, action) => {
  let id;
  switch (action.type) {
    case actionTypes.MENU_OPEN:
      id = action.id;
      return {
        ...state,
        isOpen: [id]
      };
    case actionTypes.SET_MENU:
      return {
        ...state,
        opened: action.opened
      };
    case actionTypes.SET_FONT_FAMILY:
      return {
        ...state,
        fontFamily: action.fontFamily
      };
    case actionTypes.SET_BORDER_RADIUS:
      return {
        ...state,
        borderRadius: action.borderRadius
      };
    case actionTypes.SET_THEME_MODE:
      return {
        ...state,
        navType: action.navType === 'light' ? 'light' : 'dark'
      };
    case actionTypes.SET_PALETTE:
      return isKnownPalette(action.palette) ? { ...state, palette: action.palette } : state;
    case actionTypes.SET_SIDEBAR_WIDTH: {
      if (Number(action.sidebarWidth) < SIDEBAR.collapseBelow) {
        return state.opened ? { ...state, opened: false } : state;
      }
      const width = clampSidebarWidth(action.sidebarWidth);
      if (state.opened && state.sidebarWidth === width) return state;
      return { ...state, opened: true, sidebarWidth: width };
    }
    default:
      return state;
  }
};

export default customizationReducer;